import { apiClient } from "helpers/api_helper";

export const GetCustomerEarningHistory = async (number: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Customer/GetCustomerEarningHistory?mobileNo=${number}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};